import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionReservationAdditionalFee } from "./additional-fee";

import type { HotelPolicyCategoriesAndManagerStore } from "../../../../store/categories";

type Props = {
	reservationAdditionalFeeSettings: HotelPolicyCategoriesAndManagerStore["reservationAdditionalFeeSettings"];
};

export const QuestionReservationAdditionalFeeSettings = ({ reservationAdditionalFeeSettings }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={reservationAdditionalFeeSettings}>
			<QuestionReservationAdditionalFee />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionReservationAdditionalFee.displayName = "QuestionReservationAdditionalFee";
